import { render, staticRenderFns } from "./ExportCertifications.vue?vue&type=template&id=37e9a76b&scoped=true"
import script from "./ExportCertifications.vue?vue&type=script&lang=js"
export * from "./ExportCertifications.vue?vue&type=script&lang=js"
import style0 from "./ExportCertifications.vue?vue&type=style&index=0&id=37e9a76b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e9a76b",
  null
  
)

export default component.exports